import ForwardToInbox from "@material-symbols/svg-500/rounded/forward_to_inbox.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const ForwardToInboxIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: ForwardToInbox });
	return <Icon />;
};

export default memo(ForwardToInboxIcon);
